import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import VerticalDivider from "src/components/VerticalDivider/VerticalDivider";
import { getTextValueById, isRtl } from "src/utils/helpers";

const InvoicePropertyDetails = () => {
  const { t } = useTranslation(["common", "registration", "invoice"]);
  const invoiceDetails = useSelector(
    (state: any) => state.invoices?.invoiceDetailsPopupData?.invoiceDetails
  );
  const {
    propertyID,
    buildingName,
    pRPNumber,
    addressName,
    plotNo,
    propertyType,
    serviceTerritoryId,
    tradeLicenseCode,
  } = invoiceDetails;

  const serviceTerritories = useSelector(
    (state: any) => state.lookup.allServiceTerritories
  );
  const language = useSelector((state: any) => state.lookup.language);

  return (
    <section className="invoice-body property-contact-details mt-1" style={{ direction: isRtl(language) ? "rtl" : "ltr" }}>
      <div className="invoice-body__title py-1 cell-header" style={{ textAlign: isRtl(language) ? "right" : "left" }}>
        {t("invoiceDetails.propertyDetails")}
      </div>
      <div className="invoice-header__details__info d-flex flex-column">
        <div className="invoice-header__details__info__row d-flex">
          <div className="invoice-header__details__info__row__item w-70 d-flex align-items-start  flex-column w-25">
            <h6>{t("invoiceDetails.propertyName")}</h6>
            <span>{buildingName}</span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item d-flex align-items-start flex-column w-25">
            <h6>{t("invoiceDetails.PropertyNo")}</h6>
            <span>{propertyID}</span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item w-130 d-flex align-items-start flex-column w-25">
            <h6>{t("invoiceDetails.bldgLocation")}</h6>
            <span>
              {getTextValueById(
                serviceTerritoryId,
                serviceTerritories,
                "territoryId"
              )}
            </span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item w-130 d-flex align-items-start flex-column w-25">
            <h6>{t("invoiceDetails.propertyType")}</h6>
            <span>{propertyType}</span>
          </div>
        </div>
      </div>
      <HorizontalDivider />
      <div className="invoice-header__details__info d-flex flex-column">
        <div className="invoice-header__details__info__row d-flex">
          <div className="invoice-header__details__info__row__item w-70 d-flex align-items-start  flex-column w-25">
            <h6>{t("address")}</h6>
            <span>{addressName}</span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item d-flex align-items-start flex-column w-25">
            <h6>{t("invoiceDetails.plotNo")}</h6>
            <span>{plotNo}</span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item w-130 d-flex align-items-start flex-column w-25">
            <h6>{t("invoiceDetails.licenseNo")}</h6>
            <span>{tradeLicenseCode}</span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item w-130 d-flex align-items-start flex-column w-25">
            <h6>{t("invoiceDetails.bldgPRP")}</h6>
            <span>{pRPNumber}</span>
          </div>
        </div>
      </div>
      <HorizontalDivider />
    </section>
  );
};

export default InvoicePropertyDetails;
